import { useState, useEffect, useRef } from 'react';

/**
 * 실시간 데이터 스트림에서 마지막으로 확인된 유효(non-null) 값을 유지합니다.
 * @param currentValue 현재 데이터값
 * @returns [displayValue, isStale]
 */
export function useLatestValid<T>(currentValue: T | null | undefined): [T | null, boolean] {
  const [latestValid, setLatestValid] = useState<T | null>(currentValue ?? null);

  useEffect(() => {
    if (currentValue !== null && currentValue !== undefined) {
      setLatestValid(currentValue);
    }
  }, [currentValue]);

  const isStale = (currentValue === null || currentValue === undefined) && latestValid !== null;

  return [currentValue ?? latestValid, isStale];
}
